<!--
 * @Descripttion: 整理逻辑,添加备注!!!
 * @version: 
 * @Author: Duanshuai
 * @Date: 2022-01-24 08:54:29
 * @LastEditors: ------
 * @LastEditTime: 2022-02-18 08:55:18
-->
<template>
  <div class="fangTan_container">
    <van-nav-bar
        title="请假申请记录详情"
        @click-left="$router.push('/myPageList')"
        left-arrow
        safe-area-inset-top
        placeholder
    />
    <div class="con">
      <div class="myInfo">
        <div class="info">
          <div class="title">
            <!-- <van-image width="0.5rem" height="0.5rem" :src="require('../../images/62.png')"></van-image> -->
            <span>请假申请记录详情</span>
            <div class="box">
              <div class="box_item">
                <div class="contain">
                  护理员姓名:{{ info.nurseName || '暂无填写' }}
                </div>
                <div class="contain contains">
                  医保编码:{{ info.nurseCode || "暂无填写" }}
                </div>
                <div class="contain">
                  所属门店{{ info.storeName || "暂无填写" }}
                </div>
                <div class="contain">
                  时长{{ info.duration || "暂无填写" }}
                </div>
                <div class="contain contains">
                  请假类型:{{ info.type == 1 ? '事假' : info.type == 2 ? '病假' : info.type == 3 ? '调休假' : info.type == 4 ? '婚假' : info.type == 5 ? '产假' : info.type == 6 ? '陪产假' : '其他' || "暂无填写" }}
                </div>
                <div class="contain contains">
                  开始时间:{{ info.startTime || "暂无填写" }}
                </div>
                <div class="contain contains">
                  结束时间:{{ info.endTime || "暂无填写" }}
                </div>
                <div class="contain contains">
                  审核状态:{{ info.status == 0 ? '审核中' : info.status == 1 ? '审核通过' : '审核驳回' || "暂无填写" }}
                </div>
                <div class="contain contains">
                  请假事由:{{ info.comment || "暂无填写" }}
                </div>
                <div class="contain contains">
                  照片附件:
                  <template v-if="imageList.length > 0">
                    <van-image
                      v-for="(img, index) in imageList"
                      :key="index"
                      width="1rem"
                      height="1rem"
                      :src="img"
                      fit="cover"
                      lazy-load
                      @click="previewImages(index)"
                      class="image-item"
                    />
                  </template>
                  <span v-else>暂无照片</span>
                </div>
              </div>
            </div>

            <div class="record-table" v-if="model.length > 0">
              <van-cell title="审核记录" :value="`共${model.length}条`" />
              <div class="table-flex wid">
                <div>审批人</div>
                <div>审批结果</div>
                <div>审批时间</div>
              </div>
              <div class="table-flex" v-for="(item, index) in model" :key="index">
                <div>{{ item.checkUserName || '-' }}</div>
                <div>{{ item.checkResult == 0 ? '审核中' : item.checkResult == 1 ? '通过' : item.checkResult == 2 ? '驳回' : '发起申请' || '-' }}</div>
                <div>{{ item.createTime || '-' }}</div>
              </div>
            </div>
            <div class="record-table" v-else>
              <van-cell title="暂无审核记录"/>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { getLeaveRecordDetail } from "@/api/index";
import { ImagePreview } from 'vant';
export default {
    name: "",
    components: {},
    data() {
        return {
          info : {},
          model : {},
        };
    },
    computed: {
      imageList() {
        // 处理attachment可能为空或非字符串的情况
        if (!this.info.attachment) return [];
        
        // 确保是字符串类型
        const attachment = String(this.info.attachment);
        
        // 分割字符串并过滤空值
        return attachment.split(',')
        .map(img => img.trim())
        .filter(img => img.length > 0);
      }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
      const that = this;
      that.info = that.$route.query.res || {};
      that.init();
    },
    
    // 生命周期 - 挂载完成（可以访问DOM元素）
    // 方法集合
    methods: {
      async init() {
        try {
          if (!this.info.id) {
            this.$toast('缺少请假记录ID');
            return;
          }
          
          const { data, message } = await getLeaveRecordDetail(this.info.id);
          
          if (data.code === 200) {
            this.model = data.result;
            console.log('this.model',this.model);
          } else {
            this.$toast(message || '获取记录详情失败');
          }
        } catch (error) {
          console.error('获取记录详情出错:', error);
          this.$toast('请求失败，请稍后重试');
        }
      },
      // 图片预览功能
      previewImages(startPosition = 0) {
        if (this.imageList.length === 0) {
          this.$toast('暂无图片可预览');
          return;
        }
        
        ImagePreview({
          images: this.imageList,
          startPosition,
          closeable: true,
          closeOnPopstate: true, // 浏览器返回时关闭预览
        });
      }
    },
};
</script>
<style lang="less" scoped>
html {
  height: 100vh;
  background: #f0efef;
}
body {
  margin: 0;
  background: transparent;
}

[v-cloak] {
  display: none !important;
}

.fangTan_container {
  background: #f0efef;
  width: 100%;
  height: 100vh;
}
.con {
  background: #f0efef;
}
.record-table {
  margin: 15px;
  .wid{font-weight: 600;}
  .table-flex{
    padding: 10px;
    display: flex;
    justify-content: space-between;
    background-color: wheat;
    font-size: 0.35rem;
    border-bottom: 2px dashed white; /* 默认所有行都有虚线 */
  }
  .table-flex:last-child {
    border-bottom: none; /* 最后一行取消下划线 */
  }
}

/deep/ .van-nav-bar {
  background: #0dacf4;

  .van-nav-bar__title {
    color: #fff;
  }
}

/deep/ .van-nav-bar__left {
  .van-icon,
  .van-nav-bar__text {
    color: #fff;
  }
}


.myInfo {
  margin: 14px;

  .info {
    height: 200px;

    .title {
      height: 20px;
      line-height: 20px;

      span {
        margin-left: 6px;
        font-size: 16px;
        color: #333333;
      }

      .box {
        width: 347px;
        // height: 153px;
        background: #ffffff;
        border-radius: 6px;
        margin-top: 10px;

        .box_item {
          padding: 14px 0 14px 26px;
          width: 272px;
          // height: 118px;
          font-size: 14px;
          font-family: Alibaba PuHuiTi;
          font-weight: 300;
          color: #666666;
          line-height: 26px;

          .contains {
            word-break: keep-all;
            /* 不换行 */
            width: 272px;
            overflow-x: auto;
            white-space: nowrap;
            /* 不换行 */

            .image-item {
              border-radius: 4px;
              overflow: hidden;
              cursor: pointer;
              transition: transform 0.2s;
            }

            .image-item:hover {
              transform: scale(1.05);
            }
          }
        }
      }
    }
  }

}
</style>
